import { IconProps } from '../Icons.type'

export function SantanderRoundedIcon(props: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="36"
      height="36"
      fill="none"
      viewBox="0 0 36 36"
      {...props}
    >
      <rect
        width="36"
        height="36"
        fill="url(#paint0_linear_5116_74568)"
        rx="8"
      ></rect>
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M22.9 17.16a4.3 4.3 0 0 0-.653-2.081l-3.54-5.7c-.27-.435-.456-.901-.56-1.379L18 8.238a4.28 4.28 0 0 0 0 4.56l2.831 4.561a4.29 4.29 0 0 1 0 4.56l-.147.239a4.4 4.4 0 0 0-.56-1.379l-4.248-6.84c-.27-.435-.457-.9-.56-1.379l-.148.239a4.28 4.28 0 0 0-.009 4.546L18 21.919a4.29 4.29 0 0 1 0 4.56l-.147.24a4.4 4.4 0 0 0-.56-1.38l-3.54-5.7a4.3 4.3 0 0 1-.652-2.478c-3.79.92-6.405 2.875-6.405 5.139 0 3.148 5.062 5.7 11.305 5.7s11.304-2.552 11.304-5.7c0-2.264-2.615-4.219-6.405-5.14"
        clipRule="evenodd"
      ></path>
      <defs>
        <linearGradient
          id="paint0_linear_5116_74568"
          x1="44.5"
          x2="1.898"
          y1="39.5"
          y2="45.338"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C0B5B5" stopOpacity="0"></stop>
          <stop offset="1" stopColor="#fff" stopOpacity="0.05"></stop>
          <stop offset="1" stopColor="#fff" stopOpacity="0"></stop>
        </linearGradient>
      </defs>
    </svg>
  )
}
